import type { TaiKhoanFB, TrangThaiExtension } from './kieu';

/** Chỉ nhận lựa chọn còn online; không lấy tài khoản đầu danh sách thay actor. */
export function chonTaiKhoan(ext: TrangThaiExtension | null, uidDaChon: string | null) {
  if (!ext?.connected || !ext.facebookLoggedIn) return null;
  const ds = ext.accounts || [];
  const fresh = ds.filter(t => t.identityState === 'VERIFIED' && Number.isFinite(Date.parse(t.updatedAt)) && Date.now() - Date.parse(t.updatedAt) >= -5000 && Date.now() - Date.parse(t.updatedAt) < 90000);
  const authoritative = fresh.find(t => t.identityContext?.state === 'READY' && t.identityContext.actorUid === t.uid && t.identityContext.epoch);
  if (authoritative) return authoritative;
  return uidDaChon ? fresh.find(t => t.uid === uidDaChon) || null : fresh.find(t => t.uid === ext.uid) || null;
}

export function khoaLuaChon(tenantId: string) {
  return `fbmax:${tenantId}:actor`;
}

export function choPhepAnDanh(isPage: boolean, yeuCau: boolean) {
  return !isPage && yeuCau;
}

/**
 * Chia danh sách nhóm đã chọn thành `targets` và `crossPostGroupIds` khi bật Đăng chéo.
 *
 * ===== VÌ SAO PHẢI CÓ HÀM NÀY (sửa 22/09/2026) =====
 *
 * Trước đây màn Tạo bài gửi:
 *     targets           = [...daChon]           // CẢ danh sách
 *     crossPostGroupIds = [...daChon].slice(1)  // tập CON của targets
 *
 * Máy chủ loại mọi ID đã nằm trong `targets` khỏi danh sách đăng chéo
 * (dispatch.routes.js:112-113) vì gửi một nhóm hai lần trong cùng request là lỗi
 * chắc chắn. Tập con bị loại SẠCH -> `crossPostGroupIds` rỗng -> job không mang
 * `groups_schedule_xposting` (post-builder.js:400-404). Bật Đăng chéo cho kết quả
 * y hệt không bật, mà không có lấy một thông báo nào.
 *
 * ===== VÌ SAO KHÔNG SỬA BỘ LỌC Ở MÁY CHỦ =====
 *
 * Bộ lọc đó KHÔNG phải lỗi, nó là chốt chống đăng trùng. Bỏ nó đi thì nhóm thứ 2
 * trở đi nhận bài HAI lần: một lần từ job riêng của nó, một lần từ lượt xpost của
 * nhóm gốc. Đăng trùng là dấu hiệu spam rõ nhất Facebook dùng để phát hiện tool —
 * đúng thứ cả hệ thống này đang tránh.
 *
 * Hợp đồng đúng: đăng chéo là MỘT bài đăng vào nhóm gốc rồi Facebook tự nhân bản
 * sang các nhóm còn lại. Vậy `targets` chỉ được chứa nhóm gốc.
 */
export function chiaNhomDangCheo(daChon: string[]) {
  const ds = [...daChon];
  return { targets: ds.slice(0, 1), crossPostGroupIds: ds.slice(1) };
}

export function tenActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return 'Chưa nhận diện tài khoản Facebook';
  if (taiKhoan.name) return taiKhoan.name;
  return taiKhoan.isPage ? `${taiKhoan.uid} · Chưa lấy được tên Page` : `${taiKhoan.uid} · Chưa lấy được tên`;
}

export function moTaActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return 'Chưa kết nối actor Facebook';
  const loai = taiKhoan.isPage ? 'Page' : 'Cá nhân';
  return `${taiKhoan.name || 'Chưa lấy được tên'} · ${loai} · UID ${taiKhoan.uid}`;
}

export function avatarActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return null;
  return taiKhoan.avatar || null;
}

export function tenVietTatActor(taiKhoan: TaiKhoanFB | null | undefined) {
  if (!taiKhoan) return 'FB';
  if (taiKhoan.isPage && !taiKhoan.name) return 'P';
  return (taiKhoan.name || taiKhoan.uid || 'FB').slice(0, 2).toUpperCase();
}
